import { useCallback, useEffect, useState } from 'react';
import { fetchProjects } from '../../services/api';
import Loader from '../../components/admin/ui/Loader';
import AdminProjectsSubnav from '../../components/admin/AdminProjectsSubnav';
import AdminCarouselTab from '../../components/admin/AdminCarouselTab';

function AdminProjectCarouselPage({ showToast }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    const data = await fetchProjects();
    setProjects(data || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  if (loading) return <Loader label="Chargement des projets..." />;

  return (
    <section className="admin-section">
      <h2>Projets</h2>
      <AdminProjectsSubnav />
      <AdminCarouselTab projects={projects} reload={reload} showToast={showToast} />
    </section>
  );
}

export default AdminProjectCarouselPage;
